export const openBook = (navigate, book) => {

    const extension = book.book_link.split(".").pop();

    if (extension === "pdf") {
        navigate("/pdf", {
            state: {
                message: book.book_link,
                id: book.id,
                quiz: book.game_url,
                bookImage: book.book_cover_img,
            },
        });
    } else {
        navigate("/epub", {
            state: {
                message: book.book_link,
                id: book.id,
                quiz: book.game_url,
                bookImage: book.book_cover_img,
            },
        });
    }
};